/** @format */
import { getConfig } from '@toucan/common/services/nextjs/settings';

import { CookieConsentCategories } from '@toucan/client/global/one-trust';

/**
 * Class to manage the Bloomreach SDK integration.
 */
class Bloomreach {
    private hasAttachedConsentHandler = false;

    /**
     * Checks if the user has consented to performance cookies.
     */
    private hasConsented(): boolean {
        const performanceCategory = `,${CookieConsentCategories.PERFORMANCE},`;
        return Boolean(
            window?.OnetrustActiveGroups?.includes(performanceCategory)
        );
    }

    /**
     * Checks if the Bloomreach SDK is already initialized.
     */
    private isInitialised(): boolean {
        return Boolean(window?.exponea?.isInitialized);
    }

    /**
     * Attaches a handler to monitor consent changes and initialize the SDK when consent is granted.
     */
    private attachConsentHandler(customerId?: number): void {
        if (this.hasAttachedConsentHandler) {
            return;
        }

        this.hasAttachedConsentHandler = true;

        window?.OneTrust?.OnConsentChanged?.(() => {
            if (this.hasConsented()) {
                this.initialise(customerId);
            }
        });
    }

    /**
     * Initializes the Bloomreach SDK if enabled, consented, and not already initialized.
     */
    public initialise = (customerId?: number): void => {
        const {
            publicRuntimeConfig: { bloomreachEnabled },
        } = getConfig();

        if (!bloomreachEnabled || this.isInitialised()) {
            return;
        }

        if (!this.hasConsented() && !this.hasAttachedConsentHandler) {
            this.attachConsentHandler(customerId);
            return;
        }

        window?.exponea?.start({ customer: { customer_id: customerId } });
    };
}

export const bloomreachSDK = new Bloomreach();
